import React from "react";
import { Form, Input } from "antd";
import { DealManagerComponentModalProps } from "..";
import { getDigitsOnly } from "../../../utils";

const TerritoryModal: React.FC<DealManagerComponentModalProps> = ({ form }) => {
	return (
		<>
			{/* <Form.Item
				name="id"
				label="ID"
				rules={[
					{ required: true, message: "Please input the ID!" },
				]}
			>
				<Input disabled onChange={e => form.setFieldValue("id", getDigitsOnly(e.target.value))} />
			</Form.Item> */}
			<Form.Item
				name="name"
				label="Territory Name"
				rules={[{ required: true, message: "Please input the territory name!" }]}
			>
				<Input />
			</Form.Item>
		</>
	);
};

export default TerritoryModal;
